import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IWidgetCard } from '@entities/widget-card/model/types';

export type TWidgetModalType = 'closed' | 'details' | 'payment' | 'only-admin';

export interface IWidgetModalsState {
    type: TWidgetModalType;
    widgetId: IWidgetCard['id'] | null;
}

const initialState: IWidgetModalsState = {
    type: 'closed',
    widgetId: null,
};

export const widgetModalsSlice = createSlice({
    name: 'widgetModals',
    initialState,
    reducers: {
        openDetailsModal: (state, action: PayloadAction<IWidgetCard['id']>) => {
            state.type = 'details';
            state.widgetId = action.payload;
        },
        openPaymentModal: (state, action: PayloadAction<IWidgetCard['id']>) => {
            state.type = 'payment';
            state.widgetId = action.payload;
        },
        openOnlyAdminModal: (state, action: PayloadAction<IWidgetCard['id'] | null | undefined>) => {
            state.type = 'only-admin';
            state.widgetId = action.payload ?? null;
        },
        closeWidgetModal: (state) => {
            state.type = 'closed';
            state.widgetId = null;
        },
    },
});

export const {
    openDetailsModal,
    openPaymentModal,
    openOnlyAdminModal,
    closeWidgetModal,
} = widgetModalsSlice.actions;

export const widgetModalsReducer = widgetModalsSlice.reducer;
